import PropTypes from 'prop-types';
import classnames from 'classnames';

import { DSIcon } from '@spotahome/ui-library/base';

import './ShareButtonRedesign.scss';

const isAndroid = deviceOS => /(Android)/i.test(deviceOS);

const WEB_DATA_CY = 'booknow_card_share_button';
const ANDROID_DATA_CY = 'booknow_card_android_share_button';

const ShareButtonRedesign = ({ onClick, className, deviceOS = '' }) => {
  const inAndroid = isAndroid(deviceOS);
  const dataCy = inAndroid ? ANDROID_DATA_CY : WEB_DATA_CY;

  const shareIconName = inAndroid ? 'share' : 'shared';

  return (
    <button
      className={classnames('share-button-redesign', className)}
      onClick={onClick}
      data-cy={dataCy}
      type="button"
    >
      <DSIcon name={shareIconName} />
    </button>
  );
};

ShareButtonRedesign.propTypes = {
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  deviceOS: PropTypes.string
};

export default ShareButtonRedesign;
